import { SourcedValue } from './option.js';
import { unAvailabilitySymbol } from './engine-impl.js';
export const deepCopy = (src, shallowProperties = [], setAlways = false) => {
    if (src === null) {
        return src;
    }
    if (src instanceof Date) {
        return new Date(src.getTime());
    }
    if (src instanceof Array) {
        const cp = [];
        src.forEach((v) => { cp.push(v); });
        return cp.map((n) => deepCopy(n, shallowProperties));
    }
    if (typeof src === 'object' && src !== {}) {
        if (src instanceof SourcedValue) {
            return src;
        }
        let cp = Object.assign({}, src);
        cp.__proto__ = src.__proto__;
        Object.keys(cp).forEach(k => {
            if (!shallowProperties.includes(k)) {
                cp[k] = deepCopy(cp[k], shallowProperties);
            }
        });
        if (setAlways || src.hasOwnProperty(unAvailabilitySymbol)) {
            cp[unAvailabilitySymbol] = deepCopy(src[unAvailabilitySymbol]);
        }
        return cp;
    }
    return src;
};
//# sourceMappingURL=deep-copy.js.map